import { createFileRoute } from "@tanstack/react-router";

/**
 * Spam/bot magnet: /products/* slugs from unrelated e-commerce sites are
 * constantly probed by scanners. Answer 410 Gone immediately instead of
 * rendering the full 404 app shell.
 */
export const Route = createFileRoute("/products/$")({
  server: {
    handlers: {
      GET: () =>
        new Response("Gone", {
          status: 410,
          headers: { "content-type": "text/plain; charset=utf-8" },
        }),
      HEAD: () => new Response(null, { status: 410 }),
    },
  },
  component: () => null,
});
